import { Typography, Container, Box, IconButton } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import PrintIcon from "@mui/icons-material/Print";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { GlobalContext } from "../context/GlobalContext";
import { getTrucks } from "../API/trucks";
export default function DetailAgro() {
  const { context, setContext } = useContext(GlobalContext);
  const [notaVenta, setNotaVenta] = useState(null);
  const [driver, setDriver] = useState(null);
  const [truck, setTruck] = useState(null);
  const [firma, setFirma] = useState("");
  const [ticket, setTicket] = useState(null);
  useEffect(() => {
    const fetchTicket = async () => {
      setTicket(context.selectedTicket);
      setNotaVenta(context.selectedTicket.notaVenta);
      setDriver(context.selectedTicket.choferNombre);
      setFirma(context.selectedTicket.firma);

      getTrucks().then((camiones) => {
        const filteredCamion = camiones.filter(
          (camion) => camion.Patente === context.selectedTicket.patente
        );
        setTruck(filteredCamion[0]);
      });
    };
    fetchTicket();
  }, []);

  const onClose = () => {
    localStorage.removeItem("idTicket");
    localStorage.removeItem("cuarteo");
    localStorage.removeItem("preset");
    localStorage.removeItem("tabacalOperation");
    localStorage.removeItem("odometer");
    localStorage.removeItem("bloqueID");
    localStorage.removeItem("supervisorNombre");
    localStorage.removeItem("machine");
    localStorage.removeItem("supervisorLegajo");
    localStorage.removeItem("dispatched");
    localStorage.removeItem("bloqueDescripcion");
    localStorage.removeItem("entregaBruta");
    localStorage.removeItem("notaVenta");
    setContext({
      ...context,
      page: "home",
    });
  };

  return (
    <Container
      sx={{
        "@media print": {
          margin: 0,
          padding: 0,
        },
      }}
    >
      {notaVenta != null && (
        <Box sx={{ textAlign: "center", marginTop: 3 }}>
          <Typography
            variant="h5"
            sx={{
              fontSize: "14px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            <strong>{notaVenta.RazonSocial}</strong>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            <strong>Remito: {ticket.remito || ticket.numeroVentaInt}</strong>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            <strong>**Documento no válido como factura**</strong>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            <strong>
              Tipo Comprobante: {notaVenta.TipoRemito} (Cod.Nro 91)
            </strong>
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            {" "}
            <strong>Fecha: {ticket.fin ? ticket.fin.substring(0, 8) : ''}</strong>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            CUIT: {notaVenta.CUIT}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Domicilio: Ruta Nacional 34 km 1344.5
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            C.P: (4530) Embarcación
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Nro. Inscripción IIBB: {notaVenta.NroInscripcionIIBB}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Ini. Actividades: 01/10/1995
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            ----------------------------------------------
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Cliente:{" "}
            {notaVenta.Nombre != undefined
              ? notaVenta.Nombre
              : notaVenta.RazonSocialCliente}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Dir. Entrega: {notaVenta.DireccionEntrega}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            Provincia:{" "}
            {notaVenta.Provincia != undefined
              ? notaVenta.Provincia
              : notaVenta.DescripcionProv}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            IVA: {notaVenta.CondicionIvaCliente}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            CUIT: {notaVenta.CUITCliente}
          </Typography>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            ****************************************
          </Typography>

          <Box sx={{ justifyContent: "center", display: "flex" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Producto
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                {notaVenta.CodigoProducto}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Descripción
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                {notaVenta.DescripcionProducto}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Unidad
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Lts.
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Cantidad
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                {ticket.entregaBruta}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                marginRight: 1,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  fontWeight: "bold",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                Total
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "12px",
                  "@media print": {
                    fontSize: "13px",
                  },
                }}
              >
                {ticket.entregaBruta}
              </Typography>
            </Box>
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            ****************************************
          </Typography>

          {truck != null && (
            <Typography
              variant="body1"
              sx={{
                fontSize: "12px",
                "@media print": {
                  fontSize: "13px",
                },
              }}
            >
              N° CAI: {truck.NROCAI}
            </Typography>
          )}
          {truck != null && (
            <Typography
              variant="body1"
              sx={{
                fontSize: "12px",
                "@media print": {
                  fontSize: "13px",
                },
              }}
            >
              Fecha Vto. CAI: {truck.FechaVenceCai.split("T")[0]}
            </Typography>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: 0,
            }}
          >
            {/* <img src={firma} alt="Signature" width="100px" /> */}
            <Typography
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                marginTop: "50px",
                "@media print": {
                  fontSize: "13px",
                },
              }}
            >
              ----------------------------------------------
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                fontSize: "12px",
                "@media print": {
                  fontSize: "13px",
                },
              }}
            >
              <strong>Firma</strong>
            </Typography>
          </Box>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "12px",
              "@media print": {
                fontSize: "13px",
              },
            }}
          >
            ****************************************
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "12px",

              "@media print": {
                fontSize: "13px",
                margin: 0,
              },
            }}
          >
            Chofer: {driver}
          </Typography>
          {truck != null && (
            <Typography
              variant="body1"
              sx={{
                fontSize: "12px",
                "@media print": {
                  fontSize: "13px",
                  margin: 0,
                },
              }}
            >
              Patente: {truck.Patente}
            </Typography>
          )}
        </Box>
      )}
    </Container>
  );
}
